attachEvent('.reward-card__button', 'click', (ev) => {
  const parentElem = ev.target.closest('.reward-card');
  const infoContent = parentElem.querySelector('.reward-card__info-inner');
  slideToggle(infoContent, 300, 'block');
  parentElem.classList.toggle('is-active');
});
